module.exports = "pegasus/assets/preview-4.png";